// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/PromoBanner.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/PromoBanner.tsx");
  import.meta.hot.lastModified = "1740183864612.6228";
}
// REMIX HMR END

import IconResolver from "./IconResolver";
export default function PromoBanner({
  children
}) {
  return <div className="w-full py-4 px-4 lg:px-24 hidden lg:block bg-primary-700 border-b border-secondary-400 text-neutral-100 text-sm">
      <div className="max-w-page mx-auto">
        <div className="flex">
          <div className="min-w-6">
            <IconResolver token="questionMarkCircleIcon" className="mr-1 h-6 w-6" />
          </div>
          {children}
        </div>
      </div>
    </div>;
}
_c = PromoBanner;
var _c;
$RefreshReg$(_c, "PromoBanner");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;